/**
 * Easy Appointment Booking (Servicify) – myymälävalitsimen placeholder-teksti.
 *
 * Appi näyttää myymälälistan valitsimessa pelkän "Valitse", mikä ei kerro
 * asiakkaalle mitä ollaan valitsemassa. Vaihdetaan teksti muotoon
 * "Valitse myymälä" sekä suljetussa napissa että listan ensimmäisellä rivillä.
 *
 * HUOM: ensisijainen korjaus on appin oma käännös (Easy Appointment Booking
 * > Settings > Translations). Jos/kun teksti vaihdetaan sieltä, tämän
 * tiedoston ja theme.liquidin script-rivin voi poistaa.
 *
 * Toteutus:
 * - Muutetaan vain tekstisolmun sisältöä. Ei kosketa Reactin tilaan eikä
 *   arvoihin, joten valinta ja varauksen lähetys toimivat normaalisti.
 * - React voi renderöidä valitsimen uudelleen, joten MutationObserver
 *   korjaa tekstin tarvittaessa uudestaan.
 * - Observer pyörii vain kun varauskalenteri on tai on juuri ollut auki,
 *   joten tavallisilla sivuilla se ei ole päällä.
 */
(() => {
  // Appin renderöimä placeholder → haluttu teksti. Avain on appin teksti
  // sellaisenaan, joten lisää rivi jokaiselle kielelle jota käytätte.
  const LABELS = {
    Valitse: 'Valitse myymälä/palvelupiste',
    Select: 'Select a store',
  };

  // Pysyvä koukku: appi merkitsee myymälä-/työntekijävalitsimen tällä.
  const SELECTOR = '[data-servicify="employee-selector"]';

  // Napit jotka avaavat varausmodaalin (sama logiikka kuin sanky-booking-prefill.js).
  const BOOKING_TRIGGER = '[data-href*="servicify-calendar"], [data-servicify-modal-bound], [data-servicify-product]';

  // Kuinka kauan tarkkaillaan sen jälkeen kun valitsinta ei enää näy
  // (kattaa sekä appin latautumisen että modaalin sulkemisen).
  const IDLE_MS = 20 * 1000;

  let observer = null;
  let frame = 0;
  let lastSeen = 0;

  /** Vaihtaa yhden valitsimen sisältä kaikki tunnetut placeholder-tekstit. */
  function relabel(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      // Vain täsmälleen placeholderia vastaava teksti vaihdetaan – valitun
      // myymälän nimi ei siis voi mennä rikki.
      const replacement = LABELS[node.nodeValue.trim()];
      if (replacement) node.nodeValue = replacement;
    }
  }

  function run() {
    frame = 0;

    const selectors = document.querySelectorAll(SELECTOR);
    selectors.forEach(relabel);

    if (selectors.length) lastSeen = Date.now();
    else if (Date.now() - lastSeen > IDLE_MS) stopWatching();
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(run);
  }

  function stopWatching() {
    observer?.disconnect();
    observer = null;
  }

  function startWatching() {
    lastSeen = Date.now();
    schedule();

    if (observer) return;
    observer = new MutationObserver(schedule);
    // characterData mukana, koska React voi vaihtaa pelkän tekstin
    // luomatta uusia elementtejä.
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // Appi rakentaa napin uudelleen omalla JS:llään → kuunnellaan delegoidusti.
  document.addEventListener(
    'click',
    (event) => {
      if (event.target instanceof Element && event.target.closest(BOOKING_TRIGGER)) startWatching();
    },
    true
  );

  // Kalenteri voi olla suoraan sivulla ilman modaalia (esim. /pages/varaa-aika).
  // Odotetaan sivun latautuminen, jotta tarkkailu ei kilpaile ensirenderöinnin
  // kanssa (LCP/INP), ja koska appi mountataan muutenkin vasta sen jälkeen.
  window.addEventListener('load', () => {
    if (document.querySelector('#digital_appointments_container, [id^="digital-appointments"]')) startWatching();
  });
})();
